import { useRef, useState } from 'react';
import { KeenIcon } from '@/components/keenicons';
import { toAbsoluteUrl } from '@/utils';
import { Menu, MenuItem, MenuToggle } from '@/components';
import { DropdownUser } from '@/partials/dropdowns/user';
import { DropdownNotifications } from '@/partials/dropdowns/notifications';
import { DropdownApps } from '@/partials/dropdowns/apps';
import { DropdownChat } from '@/partials/dropdowns/chat';
import { ModalSearch } from '@/partials/modals/search/ModalSearch';
import { useLanguage } from '@/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import Dialpad from '@/components/call/Dialpad';
import { useAuth } from '../../../hooks/useAuth';


const statusCallOptions = [
  { label: 'Sẵn sàng', value: 'ready', color: 'bg-green-500' },
  { label: 'Nghỉ trưa', value: 'lunch', color: 'bg-cyan-500' },
  { label: 'Nghỉ ngắn', value: 'break', color: 'bg-orange-400' },
  { label: 'Không sẵn sàng', value: 'not_ready', color: 'bg-gray-600' },
  { label: 'Xử lý sau cuộc gọi', value: 'wrap_up', color: 'bg-gray-200', disabled: true },
];

const statusChatOptions = [
  { label: 'Sẵn sàng', value: 'ready', color: 'bg-green-500' },
  { label: 'Không sẵn sàng', value: 'not_ready', color: 'bg-gray-600' },
];

const Dropdown = ({ options, selected, setSelected }) => {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find((o) => o.value === selected);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center px-3 py-1.5 border rounded-md bg-white text-sm shadow hover:bg-gray-50"
      >
        <span className={`w-2 h-2 rounded-full mr-2 ${selectedOption.color}`} />
        {selectedOption.label}
        <svg
          className="ml-2 h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-10 mt-2 w-48 bg-white border rounded-xl shadow-md">
          {options.map((item) => (
            <button
              key={item.value}
              onClick={() => {
                if (!item.disabled) {
                  setSelected(item.value);
                  setOpen(false);
                }
              }}
              disabled={item.disabled}
              className={`w-full text-left px-4 py-2 text-sm flex items-center ${item.disabled
                ? 'text-gray-400 cursor-not-allowed'
                : 'hover:bg-gray-100 text-gray-700'
                }`}
            >
              <span className={`w-2 h-2 rounded-full mr-2 ${item.color}`} />
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const HeaderTopbar = () => {
  const { isRTL } = useLanguage();
  const itemChatRef = useRef(null);
  const itemAppsRef = useRef(null);
  const itemUserRef = useRef(null);
  const itemNotificationsRef = useRef(null);
  const {userData} = useAuth()
  const avatar = userData?.avatar;


  const [callStatus, setCallStatus] = useState('ready');
  const [chatStatus, setChatStatus] = useState('ready');

  const handleShow = () => {
    window.dispatchEvent(new Event('resize'));
  };

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const handleOpen = () => setSearchModalOpen(true);
  const handleClose = () => setSearchModalOpen(false);
  // Thêm state cho Dialpad
  const [openDialpad, setOpenDialpad] = useState(false);

  return (
    <div className="flex items-center gap-2 lg:gap-3.5">

      {/* <Dropdown
        options={statusChatOptions}
        selected={chatStatus}
        setSelected={setChatStatus}
      />

      <Dropdown
        options={statusCallOptions}
        selected={callStatus}
        setSelected={setCallStatus}
      /> */}

      {/* <button className='size-8 rounded-md bg-[#E4E4E4]'>
        <FontAwesomeIcon icon={faBell} />
      </button>

      <button className='size-8 rounded-md bg-[#02B875] text-white' onClick={() => setOpenDialpad(true)}>
        <FontAwesomeIcon icon={faPhoneVolume} />
      </button>
      {openDialpad && (
        <Dialpad onClose={() => setOpenDialpad(false)} />
      )} */}
      <Menu>
        <MenuItem
          ref={itemUserRef}
          toggle="dropdown"
          trigger="click"
          dropdownProps={{
            placement: isRTL() ? 'bottom-start' : 'bottom-end',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: isRTL() ? [-20, 10] : [20, 10],
                },
              },
            ],
          }}
        >
          <MenuToggle className="btn btn-icon rounded-full">
            <img
              className="size-9 rounded-full border-2 border-success shrink-0"
              src={avatar ? avatar : toAbsoluteUrl('/media/images/icon/default-avatar.png')}
              alt=""
            />
          </MenuToggle>
          {DropdownUser({ menuItemRef: itemUserRef })}
        </MenuItem>
      </Menu>
    </div>
  );
};

export { HeaderTopbar };
